import { axiosArisChatInstance } from "../AxiosConfiguration";

/**
 * The Daily Check-In v26.1 (guide §5.1b) — aris-ai, raw, unflagged.
 *
 * The check-in is a conversation, not a form: one official session per
 * member-local day, started from the Journey card and run on the ordinary
 * Voice or Text runtime with `checkin_session_id` on every turn. The server
 * decides when it is complete; the client never submits answers.
 */

export const CHECKIN_ENTRY = { JOURNEY: "JOURNEY" };
export const CHECKIN_MODALITY = { VOICE: "VOICE", TEXT: "TEXT" };

/** `kind` on /start: the whole answer. */
export const CHECKIN_KIND = {
  STARTED: "STARTED",
  RESUMED: "RESUMED",
  COMPLETED: "COMPLETED",
};

/**
 * `POST /ARIS/v4/checkin/start` — create or resume today's official check-in.
 * A double tap is RESUMED and a finished day is COMPLETED (both 200, never an
 * error). A 404 means the member is not on v26.1: fall back to the legacy form.
 */
export const startCheckIn = async (modality, entrySurface = CHECKIN_ENTRY.JOURNEY) => {
  const res = await axiosArisChatInstance.post("/ARIS/v4/checkin/start", {
    entry_surface: entrySurface,
    modality,
  });
  return res?.data ?? null;
};

/** `POST /ARIS/v4/checkin/{id}/modality` — Voice ⇄ Text on the same session. */
export const switchCheckInModality = async (sessionId, to) => {
  const res = await axiosArisChatInstance.post(
    `/ARIS/v4/checkin/${encodeURIComponent(sessionId)}/modality`,
    { to }
  );
  return res?.data ?? null;
};

/**
 * `POST /ARIS/v4/checkin/{id}/pause` — leaving before the check-in completed.
 * `recoverable: true` → PAUSED_RECOVERABLE, and Journey offers Resume. Never a
 * completion.
 */
export const pauseCheckIn = async (sessionId, reason = "USER_EXIT", recoverable = true) => {
  const res = await axiosArisChatInstance.post(
    `/ARIS/v4/checkin/${encodeURIComponent(sessionId)}/pause`,
    { reason, recoverable }
  );
  return res?.data ?? null;
};

/** `GET /ARIS/v4/checkin/today` — the day state the Journey card renders. */
export const getCheckInToday = async () => {
  const res = await axiosArisChatInstance.get("/ARIS/v4/checkin/today");
  return res?.data ?? null;
};
